@import "../../../../../shared/styles/base";

.SegmentedControl {
  width: 100%;

  legend {
    margin-bottom: 0.5rem;
    font-size: $ds-font-size-b3;
    font-weight: $ds-font-weight-medium;
    line-height: 1.125rem;
    display: flex;
    justify-content: stretch;
    align-items: flex-end;

    &.Hidden {
      display: block;
      height: 0;
      overflow: hidden;
      margin: 0;
    }
  }

  .Options {
    display: flex;
    align-content: stretch;
    align-items: stretch;
    position: relative;
    padding: 0.25rem;
    height: 2.5rem;
    justify-content: stretch;

    &::before {
      content: " ";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 0.5rem;
      background-color: $ds-neutral-50;
      mix-blend-mode: multiply;
    }

    label {
      display: inline-flex;
      flex: 1 0 0;
    }
  }

  span {
    background-color: transparent;
    border: 0;
    appearance: none;
    color: $ds-violet-900;
    font-size: $ds-font-size-b1;
    line-height: 1rem;
    font-weight: $ds-font-weight-medium;
    padding: 0.5em 1em;
    transition: background-color 0.15s;
    border-radius: 0.25rem;
    isolation: isolate;
    text-align: center;
    flex: 1 0 0;

    @media screen and (prefers-reduced-motion: reduce) {
      transition: none;
    }
  }

  input {
    display: inline-block;
    width: 0;
    height: 0;
    appearance: none;
    overflow: hidden;

    &:checked + span {
      background-color: $white;
    }

    &:not(:checked):focus + span,
    &:not(:checked) + span:hover {
      color: $ds-violet-700;
    }

    &:focus-visible + span {
      outline-offset: -2px;
      outline: $focus-outline;
    }
  }
}
